import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';

interface MenuSubitem {
  label: string;
  icone: string;
  rota?: string;
  queryParams?: Record<string, string>;
  aberto?: boolean;
  filhos?: MenuSubitem[];
}

interface MenuGrupo {
  id: 'pericias' | 'analitico' | 'relatorios' | 'administracao' | 'help';
  titulo: string;
  icone: string;
  aberto: boolean;
  itens: MenuSubitem[];
}

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  menuAberto = true;
  menuNivel: 'principal' | 'grupo' | 'subgrupo' = 'principal';
  grupoAtivo: MenuGrupo | null = null;
  itemPaiAtivo: MenuSubitem | null = null;
  periciasSubmenuAberto = false;

  gruposMenu: MenuGrupo[] = [
    {
      id: 'pericias',
      titulo: 'Perícias',
      icone: '📁',
      aberto: false,
      itens: [
        { label: 'Lista / Workspace de Perícias', icone: '📋', rota: '/pericias', queryParams: { aba: 'Perícia' } },
        { label: 'Assistente de Perícia (BPMN)', icone: '🔁', rota: '/pericias', queryParams: { aba: 'Fluxo Assistido' } }
      ]
    },
    {
      id: 'analitico',
      titulo: 'Módulo Analítico',
      icone: '🧠',
      aberto: false,
      itens: [
        { label: 'Dashboard Analítico', icone: '📊', rota: '/modulos-analiticos', queryParams: { tela: 'dashboard' } },
        {
          label: 'Perícia Contábil',
          icone: '📘',
          aberto: false,
          filhos: [
            { label: 'Atualização Monetária', icone: '📈', rota: '/modulos-analiticos', queryParams: { tela: 'atualizacao-monetaria' } },
            { label: 'Apuração Contábil', icone: '🧾', rota: '/modulos-analiticos', queryParams: { tela: 'apuracao-contabil' } }
          ]
        },
        {
          label: 'Perícia Bancária',
          icone: '🏦',
          aberto: false,
          filhos: [
            { label: 'Revisão de Contrato Bancário', icone: '📄', rota: '/modulos-analiticos', queryParams: { tela: 'revisao-contrato-bancario' } },
            { label: 'Juros Abusivos / Revisão Contratual', icone: '⚖️', rota: '/modulos-analiticos', queryParams: { tela: 'juros-abusivos-revisao-contratual' } },
            { label: 'Juros Bancários', icone: '💹', rota: '/modulos-analiticos', queryParams: { tela: 'juros-bancarios' } },
            { label: 'Crédito Consignado', icone: '💵', rota: '/modulos-analiticos', queryParams: { tela: 'credito-consignado' } },
            { label: 'Cartão de Crédito', icone: '💳', rota: '/modulos-analiticos', queryParams: { tela: 'cartao-credito' } },
            { label: 'Extratos e Lançamentos', icone: '📑', rota: '/modulos-analiticos', queryParams: { tela: 'extratos-lancamentos' } }
          ]
        },
        {
          label: 'Justiça Trabalhista',
          icone: '⚖️',
          aberto: false,
          filhos: [
            { label: 'Acerto Rescisório', icone: '📋', rota: '/modulos-analiticos', queryParams: { tela: 'acerto-rescisorio' } },
            { label: 'Verbas Trabalhistas', icone: '🧮', rota: '/modulos-analiticos', queryParams: { tela: 'verbas-trabalhistas' } },
            { label: 'Horas Extras', icone: '⏱️', rota: '/modulos-analiticos', queryParams: { tela: 'horas-extras' } }
          ]
        },
        { label: 'Avaliação de Sociedades', icone: '🏢', rota: '/modulos-analiticos', queryParams: { tela: 'avaliacao-sociedades' } },
        { label: 'Área Tributária', icone: '🏛️', rota: '/modulos-analiticos', queryParams: { tela: 'area-tributaria' } },
        { label: 'Recuperação Judicial e Falência', icone: '🏚️', rota: '/modulos-analiticos', queryParams: { tela: 'recuperacao-judicial' } },
        { label: 'Perícia Atuarial', icone: '📐', rota: '/modulos-analiticos', queryParams: { tela: 'pericia-atuarial' } },
        { label: 'Mediação e Arbitragem', icone: '🤝', rota: '/modulos-analiticos', queryParams: { tela: 'mediacao-arbitragem' } },
        { label: 'Valuation', icone: '📈', rota: '/modulos-analiticos', queryParams: { tela: 'valuation' } }
      ]
    },
    {
      id: 'relatorios',
      titulo: 'Relatórios',
      icone: '📄',
      aberto: false,
      itens: [
        { label: 'Relatório de Perícias', icone: '📁', rota: '/relatorios', queryParams: { tela: 'pericias' } },
        { label: 'Relatório de Honorários', icone: '💰', rota: '/relatorios', queryParams: { tela: 'honorarios' } },
        { label: 'Relatório de Achados', icone: '🔎', rota: '/relatorios', queryParams: { tela: 'achados' } },
        { label: 'Relatório de Evidências', icone: '🧾', rota: '/relatorios', queryParams: { tela: 'evidencias' } },
        { label: 'Exportações', icone: '⬇️', rota: '/relatorios', queryParams: { tela: 'exportacoes' } }
      ]
    },
    {
      id: 'administracao',
      titulo: 'Administração',
      icone: '⚙️',
      aberto: false,
      itens: [
        {
          label: 'Cadastros',
          icone: '🗂️',
          aberto: false,
          filhos: [
            { label: 'Peritos e Assistentes', icone: '👥', rota: '/administracao', queryParams: { tela: 'peritos-assistentes' } },
            { label: 'Clientes e Partes', icone: '🏢', rota: '/administracao', queryParams: { tela: 'clientes-partes' } },
            { label: 'Equipe Padrão', icone: '🧑‍💼', rota: '/administracao', queryParams: { tela: 'equipe-padrao' } }
          ]
        },
        {
          label: 'Configurações',
          icone: '🔧',
          aberto: false,
          filhos: [
            { label: 'Configurações Gerais', icone: '⚙️', rota: '/administracao', queryParams: { tela: 'configuracoes' } },
            { label: 'Variáveis do Sistema', icone: '🧮', rota: '/administracao', queryParams: { tela: 'variaveis' } },
            { label: 'Diretórios de Saída', icone: '📂', rota: '/administracao', queryParams: { tela: 'diretorios' } },
            { label: 'Parâmetros de Honorários', icone: '💰', rota: '/administracao', queryParams: { tela: 'parametros-honorarios' } }
          ]
        },
        {
          label: 'Modelos do Sistema',
          icone: '📋',
          aberto: false,
          filhos: [
            { label: 'Modelos de Honorários', icone: '🧾', rota: '/administracao', queryParams: { tela: 'modelos-honorarios' } },
            { label: 'Modelos de Laudo', icone: '📑', rota: '/administracao', queryParams: { tela: 'modelos-laudo' } },
            { label: 'Modelos de Checklist', icone: '✅', rota: '/administracao', queryParams: { tela: 'modelos-checklist' } }
          ]
        },
        {
          label: 'Manutenção',
          icone: '🛠️',
          aberto: false,
          filhos: [
            { label: 'Auditoria do Sistema', icone: '🔍', rota: '/administracao', queryParams: { tela: 'auditoria' } },
            { label: 'Importação/Exportação', icone: '↕️', rota: '/administracao', queryParams: { tela: 'importacao-exportacao' } },
            { label: 'Indicadores Econômicos', icone: '📊', rota: '/administracao', queryParams: { tela: 'indicadores-economicos' } },
            { label: 'Backup Local', icone: '💾', rota: '/administracao', queryParams: { tela: 'backup' } }
          ]
        }
      ]
    },
    {
      id: 'help',
      titulo: 'Help',
      icone: '❓',
      aberto: false,
      itens: [
        { label: 'Versão', icone: '🏷️', rota: '/help/versao' },
        { label: 'Documentos de utilização', icone: '📘', rota: '/help/documentos' }
      ]
    }
  ];

  loginForm = { usuario: '', senha: '' };
  loginErro = '';
  loginCarregando = false;
  sessao: any = this.carregarSessao();

  constructor(private router: Router, private http: HttpClient) {}


  alternarSubmenuPericias(event?: Event): void {
    event?.stopPropagation();
    this.menuAberto = true;
    this.menuNivel = 'principal';
    this.grupoAtivo = null;
    this.itemPaiAtivo = null;
    this.periciasSubmenuAberto = !this.periciasSubmenuAberto;
  }

  navegarPericiasLista(): void {
    this.router.navigate(['/pericias'], { queryParams: { aba: 'Perícia' } });
    this.periciasSubmenuAberto = false;
    this.menuAberto = false;
  }

  navegarAssistenteBpmn(): void {
    this.router.navigate(['/pericias'], { queryParams: { aba: 'Fluxo Assistido' } });
    this.periciasSubmenuAberto = false;
    this.menuAberto = false;
  }


  grupoPericias(): MenuGrupo {
    return this.gruposMenu.find(g => g.id === 'pericias') || this.gruposMenu[0];
  }

  gruposMenuSecundarios(): MenuGrupo[] {
    return this.gruposMenu.filter(g => g.id !== 'pericias');
  }

  get autenticado(): boolean {
    return !!this.sessao?.token;
  }

  carregarSessao(): any {
    try {
      return JSON.parse(localStorage.getItem('peritodesk_sessao') || 'null');
    } catch {
      return null;
    }
  }

  entrarComDemo(): void {
    this.loginForm = { usuario: '', senha: '' };
    this.entrar();
  }

  entrar(): void {
    this.loginErro = '';
    this.loginCarregando = true;
    this.http.post<any>('/api/auth/login', this.loginForm).subscribe({
      next: (res) => {
        this.sessao = res;
        localStorage.setItem('peritodesk_sessao', JSON.stringify(res));
        this.loginCarregando = false;
        this.router.navigate(['/dashboard']);
      },
      error: () => {
        this.loginErro = 'Usuário ou senha inválidos.';
        this.loginCarregando = false;
      }
    });
  }

  sair(): void {
    localStorage.removeItem('peritodesk_sessao');
    this.sessao = null;
    this.loginForm = { usuario: '', senha: '' };
    this.voltarMenuPrincipal();
    this.menuAberto = true;
  }

  alternarMenu(event?: Event): void {
    event?.stopPropagation();
    this.menuAberto = !this.menuAberto;
    if (!this.menuAberto) {
      this.voltarMenuPrincipal();
    }
  }

  abrirMenuCompleto(): void {
    this.menuAberto = true;
    this.voltarMenuPrincipal();
  }

  recuarMenuAposNavegacao(): void {
    this.voltarMenuPrincipal();
    this.menuAberto = false;
  }

  abrirMenuPrincipal(): void {
    this.menuAberto = true;
  }

  voltarMenuPrincipal(): void {
    this.menuNivel = 'principal';
    this.grupoAtivo = null;
    this.itemPaiAtivo = null;
    this.periciasSubmenuAberto = false;
    this.gruposMenu.forEach(g => {
      g.aberto = false;
      g.itens.forEach(i => i.aberto = false);
    });
  }

  abrirGrupoComoTela(grupo: MenuGrupo): void {
    this.menuAberto = true;
    this.gruposMenu.forEach(g => {
      g.aberto = g === grupo;
      g.itens.forEach(i => i.aberto = false);
    });
    this.grupoAtivo = grupo;
    this.itemPaiAtivo = null;
    this.menuNivel = 'grupo';
  }

  abrirSubgrupoComoTela(item: MenuSubitem, event?: Event): void {
    event?.stopPropagation();
    if (!item.filhos?.length) {
      this.navegarParaSubitem(item);
      return;
    }
    this.itemPaiAtivo = item;
    this.menuNivel = 'subgrupo';
  }

  voltarParaGrupo(): void {
    if (this.grupoAtivo) {
      this.menuNivel = 'grupo';
      this.itemPaiAtivo = null;
      return;
    }
    this.voltarMenuPrincipal();
  }

  fecharGrupos(): void {
    this.voltarMenuPrincipal();
  }

  alternarGrupo(grupo: MenuGrupo): void {
    this.abrirGrupoComoTela(grupo);
  }

  alternarSubitem(item: MenuSubitem, event?: Event): void {
    this.abrirSubgrupoComoTela(item, event);
  }

  aoClicarFora(event: MouseEvent): void {
    // v91.4.12: não fecha o menu ao clicar fora, pois o menu secundário virou navegação em tela.
    return;
  }

  navegarParaSubitem(item: MenuSubitem): void {
    if (!item.rota) {
      this.abrirSubgrupoComoTela(item);
      return;
    }

    this.router.navigate([item.rota], { queryParams: item.queryParams || {} });
    this.recuarMenuAposNavegacao();
  }
}
